import React, {useState, useEffect, useRef, useCallback, useReducer, useMemo} from 'react';
import styled from 'styled-components';
import {useDispatch, useMappedState} from 'redux-react-hook'
import {Map, Set} from 'immutable';

import ls from 'local-storage'

import RecursiveContainersTree from "../tools/RecursiveContainersTree";

import * as actions from '../../../redux/actions/ContainersActions'

import sel_icon from '../../../assets/img/select-circle-area.svg'

function getRootContainers(containersMap, access, currentUserId) {
    let allContainers = containersMap.toArray().filter(xx => (xx?.creatorId == currentUserId));
    let allChildrenIdsSet = allContainers.reduce((st, c) => st.union((c?.childrenIds || []).reduce((sst, c_) => sst.add(c_), Set())), Set());
    let orphans = allContainers.filter(x => !allChildrenIdsSet.has(x.id)).filter(x => (x?.type == 'folder' && x?.access == access));
    return orphans;
}

export default function PrivateContainerFolderSelectorPanel(props) {
    const {
        access = 'public', // private, public, hybrid
        accessGroupId, // for privacy
        onFolderSelect = cId => {

        }
    } = props;

    const dispatch = useDispatch();
    const [expandedSet, setExpandedSet] = useState((ls('expanded_new_containers') == undefined ? [] : ls('expanded_new_containers')).reduce((st, ss) => st.add(ss), Set()));

    const [loadingItemId, setLoadingItemId] = useState(undefined);
    const [selectedId, setSelectedId] = useState(undefined);


    const {
        containersMap,
        loading,
        rootContainers,
        getChildContainers,
        selectedSlide,
        selectedSlideId,
        language,
        currentUserId
    } = useMappedState(useCallback(state => {
        return {
            currentUserId: state.users.currentUserId,
            language: state.language.language,
            rootContainers: getRootContainers(state.containers.containersMap, 'private', state.users.currentUserId),
            loading: state.containers.loading || state.slides.loading,
            containersMap: state.containers.containersMap,
            selectedSlide: state.slides.slidesMap.get(state.slides.selectedSlideId),
            selectedSlideId: state.slides.selectedSlideId,
            getChildContainers: contId => {
                let c = containersMap.get(contId);
                if (c == undefined) {
                    return [];
                }
                let {childrenIds = []} = c;
                return childrenIds.map(x => state.containers.containersMap.get(x)).filter(x => (x != undefined))
            }
        }
    }));

    useEffect(() => {
        dispatch(actions.getMyAllCompactContainers());
    }, []);

    return (
        <Wrapper>

            <RecursiveContainersTree
                hoverHighlight={false}
                showModulesList={false}
                containers={rootContainers}
                expandedSet={expandedSet}
                loadingItemId={loadingItemId}
                getChildContainers={getChildContainers}
                expandToggle={async exId => {
                    console.log('expandToggle: exId = ', exId);
                    let isExpanded = !expandedSet.has(exId);
                    let newExpandedSet = expandedSet.has(exId) ? expandedSet.delete(exId) : expandedSet.add(exId);
                    ls('expanded_new_containers', newExpandedSet.toArray());
                    setExpandedSet(newExpandedSet);
                    if (isExpanded) {
                        setLoadingItemId(exId);
                        await dispatch(actions.getChildren(exId));
                        setLoadingItemId(undefined);
                    }
                }}
                onContainerClick={cId => {
                    let c = containersMap.get(cId);
                }}
                renderRightBlockFunction={(cId, parId) => {
                    let c = containersMap.get(cId);
                    if (c == undefined) {
                        return null;
                    }
                    let hasChildren = (c.childrenIds != undefined && c.childrenIds.length > 0);
                    if (hasChildren == true) {
                        return null;
                    }
                    return (
                        <SelImg src={sel_icon}
                                style={{cursor: 'pointer'}}
                                onClick={() => {
                                    onFolderSelect(c.id);
                                }}
                        />
                    )
                }}
            />

        </Wrapper>
    );
}

const SelImg = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
  opacity: 0.5;

  :hover {
    opacity: 1;
  }
`;

const Wrapper = styled.div`
  padding: 10px;
`;
